export const COMPANY = {
  name: "Infokarta d.o.o.",
  short: "Infokarta",
  tagline: "Geodetski ured · Split, Dalmacija",
  phone: "021 345 285",
  email: "infokarta@infokarta.hr",
  address: "Visoka 59, 21000 Split",
  oib: "51812379846",
  hours: "Pon – Pet · 08:00 – 16:00",
  founded: 2002,
  projects: "2.000+",
  logo: "/img/infokarta-logo.jpg",
};

export const NAV_LINKS = [
  { to: "/", key: "home" },
  { to: "/usluge", key: "services" },
  { to: "/o-nama", key: "about" },
  { to: "/kontakt", key: "contact" },
];
